/* eslint-disable react/require-default-props */
import {
  ChangeEvent, ComponentProps, KeyboardEvent, MouseEventHandler, Ref,
} from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFeedback, Input } from 'reactstrap';

interface FieldValueType {
  id?: string;
  name: string;
  value?: string | number
  checked?: boolean;
  maxLength?: number;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  defaultValue?: string;
  autoFocus?: boolean
  hideFormError?: boolean;
  clearFormError?: boolean;
  innerRef?: Ref<HTMLInputElement | HTMLTextAreaElement> | undefined
  type: ComponentProps<typeof Input>['type'];
  onClick?: MouseEventHandler<HTMLInputElement>;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => boolean;
  customOutputHandler?: (_value: string) => void
  customInputChangeHandler?: (
    inputEvent: ChangeEvent<HTMLInputElement>
  ) => any
}

const InputField = (props: FieldValueType) => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  const {
    name,
    type,
    value,
    checked,
    placeholder,
    hideFormError,
    clearFormError,
    customOutputHandler,
    customInputChangeHandler,
    ...inputProps
  } = props;

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type={type}
            onChange={(e) => {
              if (customInputChangeHandler) {
                field?.onChange(customInputChangeHandler(e));
              } else {
                if (customOutputHandler) {
                  customOutputHandler(e.target.value);
                }
                if (type === 'checkbox' || type === 'switch') {
                  field.onChange(e.target.checked);
                } else {
                  field.onChange(e.target.value);
                }
              }
              if (clearFormError) {
                clearErrors();
              }
            }}
            placeholder={placeholder}
            value={value || field?.value}
            checked={checked}
            {...inputProps}
          />
        )}
      />

      {!hideFormError ? (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <FormFeedback>{message}</FormFeedback>
          )}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default InputField;
